import React from 'react';
import {
  Star,
  Trash,
  ChartBar,
  Table as TableIcon,
  ShareNetwork,
} from '@phosphor-icons/react';
import { AssetReportView } from 'shared/types/asset-report';

interface SavedViewsBarProps {
  views: AssetReportView[];
  onLoadView: (view: AssetReportView) => void;
  onDeleteView: (id: number) => void;
  activeViewId?: number | null;
}

const SavedViewsBar: React.FC<SavedViewsBarProps> = ({
  views,
  onLoadView,
  onDeleteView,
  activeViewId,
}) => {
  if (views.length === 0) return null;

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <div className="flex items-center gap-1.5 text-xs font-medium text-muted-foreground mr-1">
        <Star className="h-3.5 w-3.5" weight="fill" />
        <span>Opgeslagen weergaven:</span>
      </div>
      {views.map(view => {
        const isActive = activeViewId === view.id;
        return (
          <button
            key={view.id}
            onClick={() => onLoadView(view)}
            className={`group flex items-center gap-1.5 text-sm px-3 py-1.5 rounded-md border transition-colors ${
              isActive
                ? 'bg-primary text-primary-foreground border-primary'
                : 'bg-background text-foreground border-border hover:bg-accent hover:border-accent'
            }`}
          >
            {view.viewType === 'chart' ? (
              <ChartBar className="h-3.5 w-3.5 shrink-0" />
            ) : (
              <TableIcon className="h-3.5 w-3.5 shrink-0" />
            )}
            <span className="truncate max-w-[180px]">{view.name}</span>
            {view.isShared && (
              <ShareNetwork className="h-3 w-3 shrink-0 opacity-60" />
            )}
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDeleteView(view.id);
              }}
              className={`shrink-0 rounded-full p-0.5 opacity-0 group-hover:opacity-100 transition-opacity ${
                isActive
                  ? 'hover:bg-primary-foreground/20'
                  : 'hover:bg-destructive/10 hover:text-destructive'
              }`}
              title="Verwijderen"
            >
              <Trash className="h-3 w-3" />
            </button>
          </button>
        );
      })}
    </div>
  );
};

export default SavedViewsBar;
